module.exports = __webpack_public_path__ + "static/trust_the_pros_small2-64a7e3b4a978a2199394aa88a7951e8d.jpg";